import * as types from '../constants/actionTypes';
import api from '../../shared/api.json';
import uriTemplate from 'uri-template';

export function fetchFollowerDetails(id) {
    return {
        types: [
            types.FETCH_FOLLOWER_DETAILS,
            types.FETCH_FOLLOWER_DETAILS_SUCCESS,
            types.FETCH_FOLLOWER_DETAILS_FAIL,
        ],
        promise: (client) =>
            client.get(
                uriTemplate
                    .parse(api.followCompany.fetchDetails)
                    .expand({ profileId: id })
            ),
    };
}

export function followCompany(id) {
    return {
        types: [
            types.FOLLOW_COMPANY,
            types.FOLLOW_COMPANY_SUCCESS,
            types.FOLLOW_COMPANY_FAIL,
        ],
        promise: (client) =>
            client.post(
                uriTemplate
                    .parse(api.followCompany.follow)
                    .expand({ profileId: id })
            ),
    };
}

export function unfollowCompany(id) {
    return {
        types: [
            types.UNFOLLOW_COMPANY,
            types.UNFOLLOW_COMPANY_SUCCESS,
            types.UNFOLLOW_COMPANY_FAIL,
        ],
        promise: (client) =>
            client.post(
                uriTemplate
                    .parse(api.followCompany.unfollow)
                    .expand({ profileId: id })
            ),
    };
}
